/**
 * The list of languages supported by DeepL.
 * See https://developers.deepl.com/docs/resources/supported-languages
 *
 * Note that we are maintaining our own list of supported languages to avoid
 * additional API calls and will need to update this list as more language support
 * is added by DeepL.
 */
const DEEPL_TARGET_LANGUAGES = [
	'ar', 'bg', 'cs', 'da', 'de',
	'el', 'en', 'en-gb', 'en-us', 'es',
	'et', 'fi', 'fr', 'hu', 'id',
	'it', 'ja', 'ko', 'lt', 'lv',
	'nb', 'nl', 'pl', 'pt', 'pt-br',
	'pt-pt', 'ro', 'ru', 'sk', 'sl',
	'sv', 'tr', 'uk', 'zh'
];

const DEEPL_SOURCE_LANGUAGES = [
	'ar', 'bg', 'cs', 'da', 'de',
	'el', 'en', 'es', 'et', 'fi',
	'fr', 'hu', 'id', 'it', 'ja',
	'ko', 'lt', 'lv', 'nb', 'nl',
	'pl', 'pt', 'ro', 'ru', 'sk',
	'sl', 'sv', 'tr', 'uk', 'zh'
];

module.exports = {
	DEEPL_SOURCE_LANGUAGES,
	DEEPL_TARGET_LANGUAGES,
};
